module.exports = __webpack_public_path__ + "static/media/naruto.b41b30a0.png";